var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2257_1042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5C10.2556 10.7495 9.96386 10.9477 9.6419 11.0829C9.31995 11.2182 8.97423 11.2879 8.625 11.2879C8.27577 11.2879 7.93005 11.2182 7.60809 11.0829C7.28614 10.9477 6.99441 10.7495 6.75 10.5L3.75 7.50004C3.25272 7.00276 2.97335 6.3283 2.97335 5.62504C2.97335 4.92178 3.25272 4.24732 3.75 3.75004C4.24728 3.25276 4.92174 2.97339 5.625 2.97339C6.32826 2.97339 7.00272 3.25276 7.5 3.75004L7.875 4.12504",
    stroke: "#B1BAD1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50069 7.50004C7.7451 7.25059 8.03683 7.05242 8.35879 6.91713C8.68075 6.78184 9.02646 6.71216 9.37569 6.71216C9.72492 6.71216 10.0706 6.78184 10.3926 6.91713C10.7146 7.05242 11.0063 7.25059 11.2507 7.50004L14.2507 10.5C14.748 10.9973 15.0273 11.6718 15.0273 12.375C15.0273 13.0783 14.748 13.7528 14.2507 14.25C13.7534 14.7473 13.079 15.0267 12.3757 15.0267C11.6724 15.0267 10.998 14.7473 10.5007 14.25L10.1257 13.875",
    stroke: "#B1BAD1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2257_1042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.89d4340c3412ae3c731187fc528e4599.svg";
export { ForwardRef as ReactComponent };